<template>
  <div
    class="errorDiv"
    :class="{
      'icj-required': isRequired,
      'icj-required-valid': isRequired && !error,
      'icj-error': error,
    }"
    :id="'itemId' + id + index"
  ></div>
  <div class="block p-5" :class="{ 'mb-5 bg-coral-light': errorMessage }">
    <div class="flex items-center flex-wrap">
      <div class="text-gray-92 leading-4 font-semibold">
        {{ itemName }}
        <span v-if="inputQuestion" class="text-xs ml-1"
          >- {{ inputQuestion }}</span
        >
        <span
          v-if="isRequired"
          class="ml-2"
          style="color: #de2d2d; font-size: 11px"
        >
          必須
        </span>
      </div>
    </div>
    <div v-if="description" class="text-xs my-2 text-gray-62">
      {{ description }}
    </div>
    <div>
      <div
        :class="{
          block: true,
          'mt-1': true,
          rounded: true,
          'p-2': true,
        }"
      >
        <div
          v-for="item in items"
          :key="item.id"
          class="pr-2"
          :class="{
            'items-center': true,
            'inline-flex': !vertical,
            'w-1/3': !vertical,
          }"
        >
          <input
            type="radio"
            :name="'radio' + id + 'index' + index"
            :id="'itemId' + id + 'optionId' + item.id + 'index' + index"
            :data-id="item.id"
            :value="item.id"
            v-model="inputValueModel"
            :disabled="disabled"
            class="icj-display-on-off"
            :class="[disabled ? 'isDisabled' : 'isNotDisabled']"
          />
          <label
            :for="'itemId' + id + 'optionId' + item.id + 'index' + index"
            class="flex radio-label leading-4 mb-2 cursor-pointer"
          >
            <span class="ml-2 text-gray-92 body-md">{{ item.name }}</span>
          </label>
        </div>
      </div>
      <div v-if="errorMessage" class="text-danger text-xs mt-2">
        {{ errorMessage }}
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, computed } from 'vue';
import validateRules from '@/utils/validateRules.js';

export default {
  props: {
    id: Number,
    itemName: String,
    inputQuestion: String,
    description: String,
    rules: String,
    items: Array,
    inputValue: [Number, String],
    dataType: String,
    disabled: Boolean,
    isSubmit: Boolean,
    index: Number,
  },
  emits: ['update:inputValue'],
  setup(props, { emit }) {
    const state = reactive({
      error: false,
      errorMessage: '',
    });

    const inputValueModel = computed({
      get: () => {
        const result = validateRules.validate(props.inputValue, props.rules);
        if (result === true) {
          state.error = false;
        } else {
          state.error = true;
          if (props.isSubmit) state.errorMessage = result;
        }
        return props.inputValue || '';
      },
      set: (value) => {
        emit('update:inputValue', value);
        const result = validateRules.validate(value, props.rules);
        if (result === true) {
          state.error = false;
          state.errorMessage = '';
        } else {
          state.error = true;
          state.errorMessage = result;
        }
      },
    });

    const vertical = computed(() => {
      for (let i = 0; i < props.items.length; i++) {
        if (props.items[i].name.length > 16) {
          return true;
        }
      }
      return false;
    });

    const isRequired = props.rules.indexOf('required') !== -1;

    return {
      ...toRefs(state),
      inputValueModel,
      vertical,
      isRequired,
    };
  },
};
</script>

<style lang="scss" scoped>
.isNotDisabled {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  + .radio-label {
    display: flex;
    &:before {
      content: '';
      background: #fff;
      border-radius: 100%;
      border: 1px solid rgba(6, 16, 26, 0.38);
      display: inline-block;
      min-width: 16px;
      min-height: 16px;
      width: 16px;
      height: 16px;
    }
    &:hover::before {
      border: 1px solid #2cb2b2;
      box-shadow: 0px 0px 0px 2px rgba(73, 168, 174, 0.2);
    }
  }
  &:checked {
    + .radio-label {
      &:before {
        background-color: #2cb2b2;
        border: 1px solid #2cb2b2;
        box-shadow: inset 0 0 0 2px #fff;
      }
    }
  }
}

.isDisabled {
  position: absolute;
  opacity: 0;
  + .radio-label {
    display: flex;
    &:before {
      content: '';
      background: #fff;
      border-radius: 100%;
      @apply border;
      display: inline-block;
      min-width: 16px;
      min-height: 16px;
      width: 16px;
      height: 16px;
    }
  }
  &:checked {
    + .radio-label {
      &:before {
        background-color: #dde1ed;
        @apply border;
        box-shadow: inset 0 0 0 2px #fff;
      }
    }
  }
}

.errorDiv {
  position: absolute;
  top: -56px;
  left: 0;
}
</style>
